import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";
import {store} from "@/plugins/vuex";
import DynamicFieldModel from "@/core/components/input-widget/DynamicFieldModel";

export default class CustomerIdentificationFormModel extends BaseModel {
  personal_identification_number = null;
  document_type = null;
  document_number = null;
  document_issue_date = null;
  document_expiry_date = null;
  date_of_birth = null;
  citizenship_code = null;
  residency_code = null;
  country_of_birth_code = null;
  place_of_issue = null;
  company_reg_number = null;
  company_vat_tax_number = null;
  government_issued_id = [];
  proof_of_address = [];
  employment_information = [];
  company_id_documents = [];
  government_issued_id_files = [];
  proof_of_address_files = [];
  employment_information_files = [];
  deleted_files = [];
  company_id_documents_fields = []
  dynamic_fields = []

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initNonTranslatableDynamicFields();
  }

  rules = {};

  attributeHints = {};

  initNonTranslatableDynamicFields() {
    if (!store || !store.state || !store.state.global || !store.state.global.identificationDynamicFields) {
      return;
    }
    const dynamicFieldsTemplate = store.state.global.identificationDynamicFields;


    let dynamicFields = this.dynamic_fields;
    if (!dynamicFields) {
      dynamicFields = {}
    }

    for (let dynamicField of dynamicFieldsTemplate) {
      let field = `${dynamicField.key}`;
      let options = dynamicField

      if (!this[field]) {
        this[field] = '';
      }

      const availableDynamicFieldRules = [
        'min_value',
        'max_value',
        'required',
        'max_length',
        'min_length',
        'choices',
        'allow_blank'
      ];
      let rules = {};
      if (options.rules) {
        for (let rule in options.rules) {
          if (!availableDynamicFieldRules.includes(rule)) {
            continue;
          }

          if (['min_value', 'max_value', 'required'].includes(rule)) {
            rules[rule] = options.rules[rule];
          } else if (['max_length', 'min_length'].includes(rule)) {
            rules[rule.split('_')[0]] = options.rules[rule];
          }
        }
      }
      this.rules[`${field}`] = rules;
      this.attributeLabels[`${field}`] = options.label;
      this.attributeHints[`${field}`] = options.hint || "";


      if (!this[`${field}`]) {
        if (typeof dynamicField.default_value === 'object') {
          this[`${field}`] = dynamicField.default_value ? dynamicField.default_value : null
        } else {
          this[`${field}`] = dynamicField.default_value ? dynamicField.default_value : null
        }
        if (dynamicField.type === 'checkbox') {
          if (dynamicFields[field] === true || dynamicFields[field] === false) {
            this[`${field}`] = dynamicFields[field];
          } else {
            this[`${field}`] = dynamicField.default_value ? dynamicField.default_value : false;
          }
        }
      }

      // update
      if (dynamicFields[field]) {
        if (dynamicField.type === 'ckeditor') {
          this[field] = `${dynamicFields[field]}`
          this[`${field}`] = `${dynamicFields[field]}`
        } else {
          this[field] = dynamicFields[field]
          this[`${field}`] = dynamicFields[field]
        }
      } else {
        this[field] = this[`${field}`];
      }
    }
  }


  toJSON() {
    const dynamicFields = this.dynamic_fields;
    if (store && store.state && store.state.global && store.state.global.identificationDynamicFields) {
      for (let dynamicField of store.state.global.identificationDynamicFields) {
        dynamicFields[dynamicField.key] = this[`${dynamicField.key}`];
      }
    }

    return {
      personal_identification_number: this.personal_identification_number ? this.personal_identification_number.trim() : null,
      document_type: this.document_type ? this.document_type.trim() : null,
      document_number: this.document_number ? this.document_number.trim() : null,
      document_issue_date: this.document_issue_date,
      document_expiry_date: this.document_expiry_date,
      date_of_birth: this.date_of_birth,
      citizenship_code: this.citizenship_code,
      residency_code: this.residency_code,
      country_of_birth_code: this.country_of_birth_code,
      place_of_issue: this.place_of_issue,
      company_reg_number: this.company_reg_number,
      government_issued_id: this.government_issued_id,
      proof_of_address: this.proof_of_address,
      employment_information: this.employment_information,
      company_id_documents: this.company_id_documents,
      deleted_files: this.deleted_files,
      company_vat_tax_number: this.company_vat_tax_number,
      dynamic_fields: dynamicFields,
    }
  }

  attributeLabels = {
    personal_identification_number: i18n.t('Personal ID Number'),
    document_type: i18n.t('Identification Type'),
    document_number: i18n.t('Document Number'),
    document_issue_date: i18n.t('Date of Issue'),
    document_expiry_date: i18n.t('Expiration Date'),
    date_of_birth: i18n.t('Date of Birth'),
    citizenship_code: i18n.t('Citizenship'),
    residency_code: i18n.t('Residency'),
    country_of_birth_code: i18n.t('Country of Birth'),
    place_of_issue: i18n.t('Place of issue'),
    company_reg_number: i18n.t('Company Reg. Number'),
    government_issued_id: i18n.t('Government Issued ID'),
    proof_of_address: i18n.t('Proof of Address'),
    employment_information: i18n.t('Employment Information'),
    company_id_documents: i18n.t('Company ID Documents'),
    government_issued_id_file: i18n.t('Government Issued ID'),
    proof_of_address_file: i18n.t('Proof of Address'),
    employment_information_file: i18n.t('Employment Information'),
    company_id_documents_file: i18n.t('Company ID Documents'),
    trust_level: i18n.t('Trust Level'),
    total_purchases: i18n.t('Total Purchases (historic)'),
    company_vat_tax_number: i18n.t('Company VAT/Tax Number'),
  };
}
